import { isNil, isString, split } from 'lodash/fp'
import { customTranslations } from './customTranslations'

export const customTranslates = (
  product: string,
  key: string,
  options: Record<string, any>,
  defaultTranslate: (key: string, options: Record<string, any>) => string
): string => {
  const env = process.env['REACT_APP_ENV']
  const custom =
    customTranslations[env as keyof typeof customTranslations][product]
  if (isNil(custom)) return defaultTranslate(key, options)
  const items = split('.')(key)
  let customItem = custom
  for (const item of items) {
    customItem = customItem[item]
    if (isNil(customItem)) break
  }
  return !isNil(customItem) && isString(customItem)
    ? customItem
    : defaultTranslate(key, options)
}
